// src/components/ngo/CapacityIntro.jsx
import { motion } from "framer-motion";
import organizationIllustration from "../../assets/images/capacity-building/organization.svg";

const CapacityIntro = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 items-center gap-10">
        {/* Left: Text Content */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="text-left font-body"
        >
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-6">
            Why Capacity Building Matters
          </h2>

          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            At Impact Together, we believe that{" "}
            <span className="text-secondary font-semibold">
              strong institutions create stronger communities
            </span>. Our NGO Capacity Building Program helps grassroots organizations enhance their internal systems and leadership capabilities.
          </p>

          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            Through <span className="text-primary font-semibold">hands-on mentoring</span> and{" "}
            <span className="text-primary font-semibold">expert-led training</span>, we support nonprofits to plan better, act strategically, and create sustainable impact.
          </p>

          <p className="text-md text-gray-600 italic border-l-4 border-primary pl-4 mt-6">
            “We’re not just training organizations — we’re empowering changemakers to build lasting transformation.”
          </p>
        </motion.div>

        {/* Right: Illustration */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="flex justify-center"
        >
          <img
            src={organizationIllustration}
            alt="Capacity Building Illustration"
            className="max-w-md w-full drop-shadow-xl"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default CapacityIntro;
